// extracted by mini-css-extract-plugin
module.exports = {"video-container":"_3hRfg","videoContainer":"_3hRfg","video-poster":"_2IRVt","videoPoster":"_2IRVt","video-poster-img":"_1QuqS","videoPosterImg":"_1QuqS","video":"_3vVMz"};